import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUpgradeModal } from '../../../contexts/UpgradeModalContext';

export interface SubscriptionOffersPageProps {};

/**
 * Thin redirect: the /offers route opens the upgrade wizard modal
 * and navigates back to the subscription page.
 * The actual wizard lives in ModalUpgradePlan.tsx.
 */
const SubscriptionOffersPage: React.FunctionComponent<SubscriptionOffersPageProps> = () => {
  const navigate = useNavigate();
  const { openUpgradeModal } = useUpgradeModal();

  useEffect(() => {
    openUpgradeModal();
    navigate('/main/admin/subscription', { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SubscriptionOffersPage;
